import axios from "axios";
import { format, parseISO, addDays } from "date-fns";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config || {};
    const url = orig.url || "";
    if (error.response?.status === 401 && !orig._retry && !url.includes("/auth/refresh") && !url.includes("/auth/login")) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const gbp = (n) => (n == null ? "—" : `£${Number(n).toFixed(2)}`);
export const longDate = (d) => format(parseISO(d), "EEEE d MMMM");
export const shortDate = (d) => format(parseISO(d), "EEE d MMM");
export const isoDate = (d) => format(d, "yyyy-MM-dd");
export const nextDays = (n) => Array.from({ length: n }, (_, i) => isoDate(addDays(new Date(), i)));

export const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const STATUS_STYLES = {
  confirmed: "bg-sky-50 text-sky-700 border-sky-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  cancelled: "bg-rose-50 text-rose-700 border-rose-200",
  no_show: "bg-amber-50 text-amber-700 border-amber-200",
  pending_payment: "bg-slate-50 text-slate-600 border-slate-200",
  cancelling: "bg-slate-50 text-slate-600 border-slate-200",
};
export const statusLabel = (s) => (s || "").replace("_", " ");
